module.exports = window.fetch || (window.fetch = require('unfetch')["default"] || require('unfetch'));



//////////////////
// WEBPACK FOOTER
// ./~/isomorphic-unfetch/browser.js
// module id = 51
// module chunks = 2 4 8 10